import React, { useMemo, useState } from "react";
import styles from "./buyTickets.module.css";

export default function BuyTickets() {
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [showComparison, setShowComparison] = useState(false);

  const tickets = useMemo(
    () => ({
      general: {
        name: "General Pass",
        price: 299,
        code: "NIP-SOT-2026",
        deck: "Main Hall Access",
        link: "https://forms.gle/1uRVp8zKPWajpAAr6",
        features: [
          "Access to all in-person sessions in the Main Hall",
          "Exclusive opportunities to meet & network with speakers",
          "Networking with other attendees throughout the event",
          "Q&A opportunities with speakers",
          "Attendees Kit (Customized Tote Bag ,Cap ,Badges etc...)",
          "A Day at IIT Guwahati Campus",
          "Certificates of Acknowledgement",
          "Students aged 8–12 must be accompanied by an adult attendee",
          "This event is not open for children below 8 years",
        ],
        noteTitle: "Who can purchase?",
        noteText: "Open for all attendees (Non-IITG participants).",
      },
      iitg: {
        name: "IITG Pass",
        price: 249,
        code: "IITG-SOT-2026",
        deck: "Student Entry",
        link: "https://forms.gle/HfAiXRKe55VjWeW29",
        discount: 50,
        features: [
          "Valid IITG College ID card is required for entry verification",
          "Access to all in-person sessions in the Main Hall",
          "Exclusive opportunities to meet & network with speakers",
          "Networking with other attendees throughout the event",
          "Q&A opportunities with speakers",
          "Attendees Kit (Customized Tote Bag ,Cap ,Badges etc...)",
          "Certificates of Acknowledgement",
          "Students aged 8–12 must be accompanied by an adult attendee",
          "This event is not open for children below 8 years",
        ],
        noteTitle: "Eligibility",
        noteText:
          "Only the people of IITG College can purchase this pass.",
      },
    }),
    []
  );

  const selected = selectedTicket ? tickets[selectedTicket] : null;

  // stable barcode bars (not random each render)
  const makeBarcodeSeed = (code) => {
    let hash = 0;
    for (let i = 0; i < code.length; i++) {
      hash = (hash * 31 + code.charCodeAt(i)) >>> 0;
    }
    return hash;
  };

  const handleProceed = () => {
  if (!selected) return;
  window.location.href = selected.link;
};


  const makeBars = (seed, count = 42) => {
    const bars = [];
    let x = seed || 123456;
    for (let i = 0; i < count; i++) {
      x = (1103515245 * x + 12345) % 2147483648;
      const height = 45 + (x % 55);
      bars.push(height);
    }
    return bars;
  };

  return (
    <div className={styles.page}>
      {/* HEADER */}
      <div className={styles.headerWrap}>
        <div className={styles.headerCard}>
          <div className={styles.glowA} />
          <div className={styles.glowB} />

          <div className={styles.headerTop}>
            <div className={styles.brandRow}>
              <div className={styles.tedxLogo}>
                <span className={styles.x}>TEDx</span>
                <span className={styles.ted}>IIT Guwahati</span>
              </div>
            </div>

            <div className={styles.badgeRow}>
              <span className={styles.livePill}>
                <span className={styles.dot} />
                Live Event
              </span>
              <span className={styles.metaPill}>Limited Seats</span>
            </div>
          </div>

          <div className={styles.heroRow}>
            {/* BIG BOX: Theme */}
            <div className={styles.heroLeft}>
              <h1 className={styles.heroTitle}>
                The Ship <span className={styles.heroAccent}>of Theseus</span>
              </h1>

              <p className={styles.heroQuote}>
                “If you replace every plank on a ship, is it still the same vessel?”
                <br />
                <span className={styles.heroQuoteSub}>
                  A TEDx voyage into identity, change, and what truly remains the same.
                </span>
              </p>

              <div className={styles.themeCard}>
                <div className={styles.themeTitle}>About the Theme</div>
                <p className={styles.themeText}>
                  This edition explores transformation — personal, societal, and technological —
                  through stories that challenge how we define identity over time.
                </p>

                <div className={styles.themeTags}>
                  <span className={styles.tag}>Identity</span>
                  <span className={styles.tag}>Change</span>
                  <span className={styles.tag}>Becoming</span>
                  <span className={styles.tag}>Perspective</span>
                </div>
              </div>

              <div className={styles.actionsRow}>
                <button
                  onClick={() => setShowComparison((v) => !v)}
                  className={styles.compareBtn}
                >
                  {showComparison ? "Hide Comparison" : "Compare Passes"}
                  <span className={styles.chev}>{showComparison ? "▲" : "▼"}</span>
                </button>

                {/* <a href="#tickets" className={styles.primaryCta}>
                  Choose Pass →
                </a> */}
              </div>
            </div>

            {/* SMALL BOX: Details */}
            <div className={styles.heroRight}>
              <div className={styles.posterCard}>
                <div className={styles.posterTop}>
                  <div className={styles.posterLabel}>EVENT DETAILS</div>
                  <div className={styles.posterTheme}>Boarding Information</div>
                </div>

                <div className={styles.posterMid}>
                  <div className={styles.posterMetric}>
                    <span className={styles.posterMetricLabel}>Venue</span>
                    <span className={styles.posterMetricValue}>Mini Audi</span>
                  </div>
                  <div className={styles.posterMetric}>
                    <span className={styles.posterMetricLabel}>Date</span>
                    <span className={styles.posterMetricValue}>08 Feb 2026</span>
                  </div>
                  <div className={styles.posterMetric}>
                    <span className={styles.posterMetricLabel}>Time</span>
                    <span className={styles.posterMetricValue}>9 AM</span>
                  </div>
                </div>

                <div className={styles.posterBottom}>
                  <div className={styles.posterBottomText}>
                    <div className={styles.posterBottomTitle}>Main Hall • In-Person</div>
                    <div className={styles.posterBottomSub}>
                      Early entry • Networking • Speaker interactions
                    </div>
                  </div>
                  {/* <div className={styles.posterStamp}>SOT</div> */}
                </div>
              </div>
            </div>
          </div>

          <div className={styles.waveWrap}>
            <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className={styles.waveSvg}>
              <path
                d="M0,0 C150,100 350,0 600,50 C850,100 1050,0 1200,50 L1200,120 L0,120 Z"
                fill="currentColor"
              />
            </svg>
          </div>
        </div>
      </div>

      {/* Comparison */}
      {showComparison && (
        <div className={styles.tableWrap}>
          <div className={styles.tableTitleRow}>
            <h3 className={styles.sectionTitle}>Pass Comparison</h3>
            <p className={styles.sectionSub}>Choose what fits your journey.</p>
          </div>

          <div className={styles.tableScroll}>
            <table className={styles.table}>
              <thead>
                <tr className={styles.theadRow}>
                  <th className={styles.thLeft}>Benefit</th>
                  <th className={styles.thCenter}>General Pass</th>
                  <th className={styles.thCenter}>IITG Pass</th>
                </tr>
              </thead>
              <tbody>
                <tr className={styles.tr}>
                  <td className={styles.tdLabel}>Price</td>
                  <td className={styles.tdCenterStrong}>₹499</td>
                  <td className={styles.tdCenterRed}>₹299</td>
                </tr>
                <tr className={styles.tr}>
                  <td className={styles.tdLabel}>Main Hall Sessions</td>
                  <td className={styles.tdCenter}>✓</td>
                  <td className={styles.tdCenter}>✓</td>
                </tr>
                {/* <tr className={styles.tr}>
                  <td className={styles.tdLabel}>Early Theatre Admission</td>
                  <td className={styles.tdCenter}>✓</td>
                  <td className={styles.tdCenter}>✓</td>
                </tr> */}
                <tr className={styles.tr}>
                  <td className={styles.tdLabel}>Speaker Networking</td>
                  <td className={styles.tdCenter}>✓</td>
                  <td className={styles.tdCenter}>✓</td>
                </tr>
                <tr className={styles.tr}>
                  <td className={styles.tdLabel}>Lunch with Speakers</td>
                  <td className={styles.tdCenter}>✓</td>
                  <td className={styles.tdCenter}>✓</td>
                </tr>
                <tr>
                  <td className={styles.tdLabel}>Eligibility Requirement</td>
                  <td className={styles.tdCenter}>Open</td>
                  <td className={styles.tdCenter}>IITG ID</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Tickets */}
      <div id="tickets" className={styles.ticketSection}>
        <div className={styles.sectionSurface}>
          <div className={styles.sectionHead}>
            <h2 className={styles.sectionTitle}>Select your Pass</h2>
            <p className={styles.sectionSub}>Tap a card to select your pass and continue.</p>
          </div>

          <div className={styles.ticketGrid}>
            {Object.entries(tickets).map(([key, ticket]) => {
              const isSelected = selectedTicket === key;
              const isPremium = key === "iitg";

              const seed = makeBarcodeSeed(ticket.code);
              const bars = makeBars(seed, 42);

              return (
                <div
                  key={key}
                  onClick={() => setSelectedTicket(key)}
                  className={`${styles.ticketOuter} ${isSelected ? styles.ticketOuterSelected : ""}`}
                >
                  <div className={`${styles.ticketCard} ${isSelected ? styles.ticketCardSelected : ""}`}>
                    <div className={styles.ticketHeader}>
                      <div className={styles.ticketHeaderTop}>
                        <div>
                          <div className={styles.ticketTinyLabel}>Pass Code</div>
                          <div className={styles.ticketCode}>{ticket.code}</div>
                        </div>

                        <div
                          className={`${styles.badge} ${
                            isPremium ? styles.badgePremium : styles.badgeStandard
                          }`}
                        >
                          {ticket.deck}
                        </div>
                      </div>

                      <div className={styles.ticketTitleRow}>
                        <h3 className={styles.ticketName}>{ticket.name}</h3>
                        <div className={styles.priceBlock}>
                          <div className={styles.price}>₹{ticket.price}</div>
                          {ticket.discount && (
                            <div className={styles.discountText}>Save ₹{ticket.discount}</div>
                          )}
                        </div>
                      </div>

                      <div className={styles.ticketHint}>{ticket.noteText}</div>
                    </div>

                    <div className={styles.ticketBody}>
                      <div className={styles.featuresHeader}>
                        <div className={styles.featuresTitle}>Benefits</div>
                        <div className={styles.featuresLine} />
                      </div>

                      <div className={styles.featureList}>
                        {ticket.features.map((f, idx) => (
                          <div key={idx} className={styles.featureItem}>
                            <span className={styles.featureDot} />
                            <span className={styles.featureText}>{f}</span>
                          </div>
                        ))}
                      </div>

                      <div className={styles.noteBox}>
                        <div className={styles.noteTitle}>{ticket.noteTitle}</div>
                        <div className={styles.noteText}>{ticket.noteText}</div>
                      </div>

                      <button
                        className={`${styles.selectBtn} ${
                          isSelected ? styles.selectBtnSelected : styles.selectBtnDefault
                        }`}
                      >
                        {isSelected ? "Selected ✓" : "Select Pass"}
                      </button>
                    </div>

                    <div className={styles.barcodeWrap}>
                      <div className={styles.barcodeBars}>
                        {bars.map((h, i) => (
                          <div key={i} className={styles.bar} style={{ height: `${h}%` }} />
                        ))}
                      </div>
                      <div className={styles.barcodeText}>{ticket.code}-TEDX</div>
                    </div>
                  </div>

                  <div className={`${styles.corner} ${styles.cornerTL}`} />
                  <div className={`${styles.corner} ${styles.cornerTR}`} />
                  <div className={`${styles.corner} ${styles.cornerBL}`} />
                  <div className={`${styles.corner} ${styles.cornerBR}`} />
                </div>
              );
            })}
          </div>

          {/* Checkout */}
          {selected && (
            <div className={styles.checkoutWrap}>
              <div className={styles.checkoutCard}>
                <div className={styles.checkoutLeft}>
                  <div className={styles.checkoutTitle}>Continue Booking</div>
                  <div className={styles.checkoutSub}>
                    Selected: <span className={styles.checkoutStrong}>{selected.name}</span> •{" "}
                    <span className={styles.checkoutMuted}>{selected.deck}</span>
                  </div>
                </div>

                <button className={styles.checkoutBtn} onClick={handleProceed}>Proceed →</button>
              </div>

              <div className={styles.legalText}>
                This independent TEDx event is operated under license from TED.
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
